import React from "react";
import { hot } from "react-hot-loader";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import getStore from "./utils/getStore";
import BlogDetailPage from "./components/site/page/BlogDetail";

function BlogsRoot() {

    return (
        <Provider store={getStore()}>
            <React.Fragment>
                <BlogDetailPage blogId={window.ENV.BLOG_ID} />
                <ToastContainer />
            </React.Fragment>
        </Provider>
    );
}

if (DEVELOPMENT) {
    BlogsRoot = hot(module)(BlogsRoot);
}

export default BlogsRoot;
